import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";
import { X } from "lucide-react";
import {
  PrimaryCTAButton,
  SecondaryCTAButton,
} from "../../components/CTAButtonComponents";
import { useGetAllCompanyFiles } from "../../queries/onboarding";
import { FileExplorer, FileTree } from "./FileExplorer";
import Loader from "../../utils/loader";

type Props = {
  cin: string;
  showPopup: boolean;
  onClose: () => void;
  onFileSelect: Function;
};

export const CompanyFilesPopup = ({
  showPopup,
  onClose,
  cin,
  onFileSelect,
}: Props) => {
  const { data: _allCompanyFiles, isFetched } = useGetAllCompanyFiles(cin);

  return (
    <Transition.Root show={showPopup} as={Fragment}>
      <Dialog as="div" className="relative z-10 w-[500px]" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="w-10/12 h-full transform overflow-hidden rounded-lg bg-white p-6 shadow-xl transition-all">
                <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <Dialog.Title
                    as="h3"
                    className="text-base font-semibold leading-6 text-gray-900"
                  >
                    <div className="flex justify-between items-center">
                      <h2>Company Documents</h2>
                      <X
                        className="text-gray-500 hover:text-primary cursor-pointer"
                        onClick={onClose}
                      />
                    </div>
                  </Dialog.Title>
                  <div className="mt-2">
                    <div>
                      {isFetched ? (
                        <FileExplorer
                          data={_allCompanyFiles as FileTree}
                          cin={cin}
                          onFileSelect={(value) => {
                            onFileSelect(value);
                          }}
                          onClose={onClose}
                        />
                      ) : (
                        <div className="h-[375px] my-8">
                          <Loader />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
